let impressionViewableCheck = false;
let impressionCheck = false;
let objName = 'listing';

function sender(obj, max_retries = 5) {
  if (max_retries) {
      if (!window.Lurker) {
          setTimeout(() => {sender(obj, max_retries-1)}, 500);
      } else {
        window.Lurker.send({...obj})
      }
  } else {
    console.log(obj)
  }
}

function impressionsTracking(objDetail, objId, algorithmVal, versionVal, listId) {
  const sendLurker = (eventType) => {
    let objTmp = {};
    const baseData = {
      algorithm: algorithmVal,
      algorithm_version: versionVal
    };

    if (Array.isArray(listId)) {
      const ads = listId.map(item => parseInt(item.list_id, 10));
      objTmp = { ads: JSON.stringify(ads) };
    } else {
      objTmp = { list_id: listId };
    }

    Object.assign(baseData, objTmp);

    sender({
      event_type: eventType,
      object_name: objName,
      object_detail: objDetail,
      data: baseData
    });
  };

  const isView = () => {
    let positionClass = 0;
    let windowX = 0;

    if (document.getElementById(`${objId}`)[0]) {
      positionClass = document.getElementById(`${objId}`)[0].offsetTop;
      windowX = window.scrollY;
    }
    return positionClass >= windowX && positionClass < windowX + window.innerHeight;
  };

  if (isView()) {
    impressionViewableCheck = true;
    sendLurker('impression_viewable');
  }

  window.addEventListener('scroll', () => {
    if (isView() && !impressionViewableCheck) {
      impressionViewableCheck = true;
      sendLurker('impression_viewable');
    }
  });

  if (!impressionCheck) {
    impressionCheck = true;
    sendLurker('impression');
  }
}

function eventTracking(eventType, objDetail, algorithmVal, versionVal) {
    const baseData = {
      algorithm: algorithmVal,
      algorithm_version: versionVal
    };

    sender({
      event_type: eventType,
      object_name: objName,
      object_detail: objDetail,
      data: baseData
    });
}

function clickTracking(objDetail, algorithmVal, versionVal, listId, adPosition) {
  const baseData = {
    algorithm: algorithmVal,
    algorithm_version: versionVal,
    list_id: listId,
    adPosition: adPosition
  };
  
  sender({
    event_type: 'click',
    object_name: objName,
    object_detail: objDetail,
    data: baseData
  });
}

function failureTracking(objDetail, statusCode) {
  const baseData = {
    status_code: statusCode
  };

  sender({
    event_type: 'impression',
    object_name: objName,
    object_detail: `${objDetail}_failure`,
    data: baseData
  });
}

export { impressionsTracking, clickTracking, failureTracking, eventTracking };



// WEBPACK FOOTER //
// ./src/scripts/tracking.js